export const GETSTOCK_SUCCESS = "GETSTOCK_SUCCESS";
export const GETSTOCK_ERROR = "GETSTOCK_ERROR";